import React from 'react';

const RegistryEditorContent = ({ scenario, onComplete }) => {
  return (
    <div className="h-full bg-white">
      <div className="flex h-full">
        <div className="w-1/3 border-r border-gray-200 p-2">
          <div className="text-sm font-mono">
            <div className="cursor-pointer hover:bg-gray-100 p-1">📁 Computer</div>
            <div className="ml-4 cursor-pointer hover:bg-gray-100 p-1">📁 HKEY_CURRENT_USER</div>
            <div className="ml-4 cursor-pointer hover:bg-gray-100 p-1">📁 HKEY_LOCAL_MACHINE</div>
          </div>
        </div>
        <div className="flex-1 p-4">
          <p className="text-sm text-gray-600">Registry Editor simulation</p>
        </div>
      </div>
    </div>
  );
};

export default RegistryEditorContent;

